<template>
    <div id="main-section-P-BDT">
        <div id="section-content-bolsaTrabajo">
           <p>El Poder Judicial del Estado de Aguascalientes a través de la Oficialía Mayor y la Dirección de Administración de Personal te ofrece este vínculo para enviar información relacionada con tu Currículum Vitae.</p>
           <p>Una vez recibida tu información quedarás registrado en las listas de candidatos a ingresar a nuestra institución, por lo que es muy importante que tu información sea correctamente enviada.</p>
           <p>Cuando exista alguna vacante y cuentes con los conocimientos, habilidades y aptitudes serás contactado vía telefónica y/o correo electrónico por la Dirección de Administración de Personal para iniciar el proceso de valoración y evaluación de la información proporcionada en tu Currículum Vitae, además de dar seguimiento a las disposiciones relacionadas y establecidas para el ingreso al Poder Judicial del Estado de Aguascalientes.</p>
           <p>Nuestra Institución agradece tu interés para formar parte del equipo de trabajo</p>
           <div >
            <a href="https://themisfsweb.poderjudicialags.gob.mx/SICPO/Avisos%20de%20privacidad/Aviso%20de%20privacidad%20simplificado%20(2).pdf" style="font-size: large;">Aviso de Privacidad Simplificado</a><br>
            <a href="https://themisfsweb.poderjudicialags.gob.mx/SICPO/Avisos%20de%20privacidad/Aviso%20de%20privacidad%20integral%20del%20Poder%20Judicial%20del%20Estado.pdf" style="font-size: large;">Aviso de Privacidad Integral</a><br>
            <label  style="font-size: large;"><input type="checkbox" /> Acepto términos y condiciones del aviso de privacidad</label>&nbsp;&nbsp; <button @click="acepto_terminos=!acepto_terminos"  class="btn btn-success">Aceptar</button>
           </div>
           <div v-if="acepto_terminos" class="text-center mt-4" style="gap: 2em !important;">
                <div id="wrapper-link-contact">
                    <strong><a :href="getStrMailTo()" id="contacto-vinculo">Contacto</a></strong>
                </div>
                <p id="text-contact">Contacto:</p>
                <qr id="qr" :text="EMAIL_CONTACTO" ></qr>
                <a id="qr-link" :href="getStrMailTo()">{{ EMAIL_CONTACTO }}</a>
           </div>
           <br><br>
          
        </div>
    </div>
</template>
<script>
import VueQRCodeComponent from 'vue-qrcode-component'

Vue.component('qr-component', VueQRCodeComponent)
export default {
    props: {
        seccionDeLaPaginaWeb: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    data() {
        return {
            acepto_terminos:false,
            btn_aceptar:false,
            EMAIL_CONTACTO: 'recluta@poderjudicialags.gob.mx'
        }
    },
    methods: {
        getStrMailTo: function() {
            return (`mailto:${ this.EMAIL_CONTACTO }`);
        }
    }
}
</script>
<style scoped>
#main-section-P-BDT {
    display: flex;
    justify-content: center;
    padding: 4em 0 0 0;
}

#section-content-bolsaTrabajo p {
    font-size: 1.5em;
    color: rgb(129, 126, 126);
}

#section-content-bolsaTrabajo {
    width: 50%;
}

#qr {
    display: inline-block ;
    zoom: 60%
}

#qr-link {
    display: none;
    color: black;
    text-decoration: underline;
    font-size: 1em;
}

#contacto-vinculo {
    color: rgb(50,50,50) !important; 
    text-decoration: underline;
    font-size: 1.8em;
}

#wrapper-link-contact {
    margin-bottom: 1em;
}

#text-contact {
    display: none;
}

@media screen and (max-width: 1000px) {

    #section-content-bolsaTrabajo p {
        font-size: 1.1em !important;
    }

    #section-content-bolsaTrabajo {
        width: 80% !important;
    }
}

@media screen and (max-width: 400px) {
    #qr {
        display: none;
    }

    #qr-link {
        display: inline-block;
    }

    #text-contact {
        display: block;
        color: black !important;
    }

    #wrapper-link-contact {
        display: none;
    }

    #section-content-bolsaTrabajo p {
        font-size: 1em !important;
    }

    #section-content-bolsaTrabajo {
        width: 80% !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/PaginasInformativas/BolsaDeTrabajo/CBolsaDeTrabajo.vue